import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface VarianceModuleState {
  TabStripPosition: number;
  VarianceNoteDialogOpen: boolean;
  VarianceDocumentDialogOpen: boolean;
  VarianceIndividualTypeModalOpen: boolean;
  VarianceSelectedIndividualType: string;
  VarianceInitiatePatientSearchDialogOpen: boolean;
  VarianceIdentificationDetailsDialogOpen: boolean;
  VarianceSelectedIncidentTypes: string;
  VarianceSelectedIncidentTypeDetail: [string, boolean];
  IncidentCommentAddModal: boolean;
  IncidentCommentEditModal: boolean;
  IncidentCommentDeleteModal: boolean;
  SelectedCommentForEdit: any;
  SelectedCommentForDelete: any;
  IncidentWitnessModalOpen: boolean;
  IncidentAssignUserModalOpen: boolean;
  IncidentRejectCommentModalOpen: boolean;
  IncidentDocumentDialogOpen: boolean;
  IncidentReportingDepartmentDialogOpen: boolean;
  DirectorResponseAddModal: boolean;
  DirectorResponseEditModal: boolean;
  DirectorResponseDeleteModal: boolean;
  SelectedDirectorResponseForEdit: any;
  SelectedDirectorResponseForDelete: any;
}

const initialState: VarianceModuleState = {
  TabStripPosition: 0,
  VarianceNoteDialogOpen: false,
  VarianceDocumentDialogOpen: false,
  VarianceIndividualTypeModalOpen: false,
  VarianceSelectedIndividualType: "",
  VarianceSelectedIncidentTypes: "",
  VarianceInitiatePatientSearchDialogOpen: false,
  VarianceIdentificationDetailsDialogOpen: false,
  VarianceSelectedIncidentTypeDetail: ["", false],
  IncidentCommentAddModal: false,
  IncidentCommentEditModal: false,
  IncidentCommentDeleteModal: false,
  SelectedCommentForEdit: null,
  SelectedCommentForDelete: null,
  IncidentWitnessModalOpen: false,
  IncidentAssignUserModalOpen: false,
  IncidentRejectCommentModalOpen: false,
  IncidentDocumentDialogOpen: false,
  IncidentReportingDepartmentDialogOpen: false,
  DirectorResponseAddModal: false,
  DirectorResponseEditModal: false,
  DirectorResponseDeleteModal: false,
  SelectedDirectorResponseForEdit: null,
  SelectedDirectorResponseForDelete: null,
};

export const VarianceModuleSlice = createSlice({
  name: "VarianceModuleSlice",
  initialState,
  reducers: {
    setTabStripPosition: (state, action: PayloadAction<number>) => {
      state.TabStripPosition = action.payload;
    },
    setVarianceSelectedIncidentTypes: (
      state,
      action: PayloadAction<string>
    ) => {
      state.VarianceSelectedIncidentTypes = action.payload;
    },
    toggleIndividualTypeModal: (state) => {
      state.VarianceIndividualTypeModalOpen =
        !state.VarianceIndividualTypeModalOpen;
    },
    toggleVarianceSelectedIdentType: (
      state,
      action: PayloadAction<string>
    ): void => {
      state.VarianceSelectedIndividualType = action.payload;
      state.VarianceInitiatePatientSearchDialogOpen =
        state.VarianceSelectedIndividualType === "Patient";
      state.VarianceIdentificationDetailsDialogOpen =
        state.VarianceSelectedIndividualType === "Visitor" ||
        state.VarianceSelectedIndividualType === "Other";
    },
    toggleInitiatePatientSearchDialog: (state) => {
      state.VarianceInitiatePatientSearchDialogOpen =
        !state.VarianceInitiatePatientSearchDialogOpen;
    },
    toggleIdentificationDetailsDialog: (state) => {
      state.VarianceIdentificationDetailsDialogOpen =
        !state.VarianceIdentificationDetailsDialogOpen;
    },
    toggleIncidentTypeDetailOption: (
      state,
      action: PayloadAction<[string, boolean]>
    ) => {
      state.VarianceSelectedIncidentTypeDetail = action.payload;
    },
    toggleIncidentCommentAddModal: (state) => {
      state.IncidentCommentAddModal = !state.IncidentCommentAddModal;
    },
    toggleIncidentCommentEditModal: (state, action: PayloadAction<any>) => {
      state.IncidentCommentEditModal = !state.IncidentCommentEditModal;
      state.SelectedCommentForEdit = action.payload;
    },
    toggleIncidentCommentDeleteModal: (state, action: PayloadAction<any>) => {
      state.IncidentCommentDeleteModal = !state.IncidentCommentDeleteModal;
      state.SelectedCommentForDelete = action.payload;
    },
    toggleIncidentRejectCommentModal: (state) => {
      state.IncidentRejectCommentModalOpen =
        !state.IncidentRejectCommentModalOpen;
    },
    toggleWitnessModal: (state) => {
      state.IncidentWitnessModalOpen = !state.IncidentWitnessModalOpen;
    },
    toggleIncidentAssignUserDialog: (state) => {
      state.IncidentAssignUserModalOpen = !state.IncidentAssignUserModalOpen;
    },
    toggleIncidentDocumentDialog: (state) => {
      state.IncidentDocumentDialogOpen = !state.IncidentDocumentDialogOpen;
    },
    toggleIncidentReportingDepartmentDialog: (state) => {
      state.IncidentReportingDepartmentDialogOpen =
        !state.IncidentReportingDepartmentDialogOpen;
    },
    toggleDirectorResponseAddModal: (state) => {
      state.DirectorResponseAddModal = !state.DirectorResponseAddModal;
    },
    toggleDirectorResponseEditModal: (state, action: PayloadAction<any>) => {
      state.DirectorResponseEditModal = !state.DirectorResponseEditModal;
      state.SelectedDirectorResponseForEdit = action.payload;
    },
    toggleDirectorResponseDeleteModal: (state, action: PayloadAction<any>) => {
      state.DirectorResponseDeleteModal = !state.DirectorResponseDeleteModal;
      state.SelectedDirectorResponseForDelete = action.payload;
    },
  },
});

export const {
  setTabStripPosition,
  setVarianceSelectedIncidentTypes,
  toggleIndividualTypeModal,
  toggleVarianceSelectedIdentType,
  toggleInitiatePatientSearchDialog,
  toggleIdentificationDetailsDialog,
  toggleIncidentTypeDetailOption,
  toggleIncidentCommentAddModal,
  toggleIncidentCommentEditModal,
  toggleIncidentCommentDeleteModal,
  toggleWitnessModal,
  toggleIncidentAssignUserDialog,
  toggleIncidentRejectCommentModal,
  toggleIncidentDocumentDialog,
  toggleIncidentReportingDepartmentDialog,
  toggleDirectorResponseAddModal,
  toggleDirectorResponseEditModal,
  toggleDirectorResponseDeleteModal,
} = VarianceModuleSlice.actions;

export default VarianceModuleSlice.reducer;
